// Link to the permissions page (#601), e.g. from a role or a settings screen.
// role: the role uuid. groupKey: the catalog's group_key ("access_roles",
// "conversations", "integrations"...). Both are optional: without a role the
// page opens the first one, without a group_key it shows every group.
export function permissionsUrl({ role, groupKey } = {}) {
  const params = new URLSearchParams();
  if (role) params.set('role', role);
  if (groupKey) params.set('group_key', groupKey);
  const query = params.toString();
  return query ? `/permissions?${query}` : '/permissions';
}
